/* 周瑜傳・第 3 章下半：南郡（下）・擽陣與自興（建安十三年～十四年，208–209）
 * 史實：《三國志·周瑜傳》「寧圍既解，乃渡屯北岸，剋期大戰。瑜親跨馬擽陳，會流矢中右脅，瘡甚，便還。
 *       後仁聞瑜臥未起，勒兵就陳。瑜乃自興，案行軍營，激揚吏士，仁由是遂退。」
 *       《吳主傳》：「瑜、仁相守歲餘，所殺傷甚眾。仁委城走。」
 * 流程：剋期大戰：周瑜帶程普、甘寧與吳兵衝到曹仁陣前擽陣（交戰一陣子）→ 流矢中右脅（劇情，躲不掉），瘡甚，退回中軍大帳 →
 *       臥床：曹仁聽說周瑜起不來，勒兵就陳，營中士氣一路往下掉 →
 *       自興：周瑜帶傷巡營。五處營落各有士氣，走到營旗下站一會兒就「激揚吏士」（士氣滿、兵加攻）；士氣掉到零的營落就潰散。
 *       傷口：自興之後每放一次技能，傷口就迸裂一次（扣血）。曹仁大軍壓到營前時，五處營落都還站得住（最多潰散一處、平均士氣過半）→ 仁由是遂退。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, TROOPS, hero, rout } from '../kit.ts';
import { banner, walkTo } from './zhouyu_kit.ts';
import { CAMP, TENT, STATIONS, LINE } from '../maps/zhouyu_nanjun.ts';

const LV = 13, SKIRMISH = 22, LIE = 8, CAO_T = 100, DECAY = 0.95, FEAR = 1.1, RALLY_T = 1.2, RALLY_CD = 6, BLEED = 0.07, FRONT = [3500, 2300];
const CAOJUN = { spec: TROOPS.wei, name: '曹軍', hp: 460, maxHp: 460, atk: 24 };

export default {
  id: 'zhouyu-3b', of: 'zhouyu-3', map: 'zhouyu_nanjun', hero: 'zhouyu',
  title: '第 3 章　南郡（下）・擽陣自興', year: '建安十三年（208）',
  brief: {
    quote: [{ text: '瑜乃自興，案行軍營，激揚吏士，仁由是遂退。', src: '《三國志·吳書·周瑜傳》' }],
    text: '夷陵解圍後，吳軍渡到北岸紮營，和曹仁約期大戰。',
    goals: ['跨馬擽陣', '中箭後退回大帳', '帶傷巡營，激揚吏士', '曹仁兵臨營前時，五處營落都站得住'],
  },
  words: { ally: '吳兵', foe: '曹軍' },
  stars: [
    { text: '夷陵：三條險道都斷了（獲馬）', ok: (m) => !m.prev || !!m.prev.vars.cutAll },
    { text: '五處營落沒有一處潰散', ok: (m) => m.vars.broken === 0 },
    { text: '如史：自興之後不動刀兵（沒有放技能）', ok: (m) => !m.vars.bled },
  ],
  steps: [
    { // 0. 剋期大戰，跨馬擽陣
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = FRONT[0]; me.y = FRONT[1];
        V.broken = 0; V.bled = 0; V.rallies = 0;
        V.cp = ally(w, 'chengpu', FRONT[0] - 120, FRONT[1] - 120, LV);
        V.gn = ally(w, 'ganning', FRONT[0] - 120, FRONT[1] + 120, LV);
        V.men = Array.from({ length: 8 }, (_, i) => { const u = m.recruit(FRONT[0] - 200 - (i % 4) * 45, FRONT[1] - 80 + Math.floor(i / 4) * 160, '吳兵'); m.join(u, me); return u; });
        V.cr = boss(w, hero('caoren'), LINE[0] + 300, LINE[1], { name: '曹仁', hp: 6000, atk: 60, armor: 9, ms: 230, untargetable: true });
        V.cr.think = 99; V.cr.home = [LINE[0] + 300, LINE[1]];
        V.line = Array.from({ length: 14 }, (_, i) => m.foe('huangjin', LINE[0] - 60 + (i % 2) * 90, LINE[1] - 420 + Math.floor(i / 2) * 140, CAOJUN));
        // 營落：每處三個兵守著營旗
        V.st = STATIONS.map(([name, x, y], k) => {
          const s = { name, x, y, mo: 100, broken: false, last: -99 };
          s.flag = m.folk(x, y - 30, { name, still: true, near: 1, draw: banner, st: s });
          s.men = Array.from({ length: 3 }, (_, i) => { const u = m.recruit(x - 70 + i * 70, y + 50, '守營兵'); u.home = [u.x, u.y]; return u; });
          return s;
        });
        m.card('寧圍既解，乃渡屯北岸，剋期大戰。', '《周瑜傳》');
        m.line('周瑜', '今日之戰，我親自擽陣。隨我衝！');
        m.mark('line', LINE[0], LINE[1], '曹仁陣');
        m.obj('skirmish', '跨馬擽陣：衝到曹仁陣前交戰');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        if (m.near(me, LINE[0], LINE[1], 650)) V.skT = (V.skT || 0) + dt;
        m.get('skirmish').text = V.skT ? `跨馬擽陣（${Math.min(SKIRMISH, V.skT | 0)}/${SKIRMISH} 秒）` : '跨馬擽陣：衝到曹仁陣前交戰';
        return V.skT >= SKIRMISH;
      },
    },
    { // 1. 流矢中右脅，便還
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('skirmish'); m.unmark('line');
        w.fx({ k: 'spark', x: me.x, y: me.y - 40, col: '#ffe0a0' });
        me.hp = Math.min(me.hp, me.maxHp * 0.3);
        w.addBuff(me, { id: '瘡甚', t: 9999, neg: true, ms: -0.2, atkP: -0.3 });
        m.big('流矢中右脅！');
        m.card('瑜親跨馬擽陳，會流矢中右脅，瘡甚，便還。', '《周瑜傳》');
        m.line('程普', '都督中箭了！護著都督回營！');
        for (const u of V.line) if (u.alive) walkTo(u, u.x + 500, u.y); // 曹軍也退回陣中
        m.after(4, () => { for (const u of V.line) if (u.alive) { u.think = 0.3; u.home = [u.x, u.y]; } });
        V.cp.hold = [STATIONS[0][1] + 80, STATIONS[0][2] - 100]; V.gn.hold = [STATIONS[0][1] + 80, STATIONS[0][2] + 100];
        m.mark('tent', TENT[0], TENT[1], '中軍大帳');
        m.obj('back', '退回中軍大帳');
      },
      tick(m, w) { return m.near(w.player, TENT[0], TENT[1], 140); },
    },
    { // 2. 臥未起；仁勒兵就陳
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('back'); m.unmark('tent');
        V.lieT = w.t; V.lying = true;
        me.hp = Math.max(me.hp, me.maxHp * 0.45);
        m.card('後仁聞瑜臥未起，勒兵就陳。', '《周瑜傳》');
        m.after(3, () => m.line('吳兵', '曹仁出城列陣了……聽說都督起不來了……'));
        // 曹仁大軍出陣，往營前壓
        V.army = Array.from({ length: 18 }, (_, i) => m.foe('huangjin', LINE[0] + 200 + (i % 3) * 90, LINE[1] - 400 + Math.floor(i / 3) * 160, CAOJUN));
        V.cr.untargetable = false;
        V.marchT = w.t;
      },
      tick(m, w) {
        const me = w.player;
        me.input.moveTo = null; me.input.target = null; // 臥床：動不了
        me.x = TENT[0]; me.y = TENT[1];
        return w.t - m.vars.lieT > LIE;
      },
    },
    { // 3. 自興，案行軍營，激揚吏士
      enter(m, w) {
        const me = w.player, V = m.vars;
        V.lying = false; V.upT = w.t; V.cd0 = me.cd.slice();
        m.card('瑜乃自興，案行軍營，激揚吏士。', '《周瑜傳》');
        m.line('周瑜', '我還站得起來。傳令各營：周公瑾在此！');
        m.after(4, () => m.line('提示', '走到各營的營旗下站一會兒，就能激揚吏士（士氣滿、兵加攻）。士氣掉到零的營落會潰散；你在附近時士氣掉得慢。傷口未癒：放技能會迸裂扣血。'));
        V.st.forEach((s, k) => m.mark('s' + k, s.x, s.y, s.name, true));
        m.obj('rally', '');
        m.obj('cao', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, left = CAO_T - (w.t - V.upT);
        // 激揚吏士
        V.st.forEach((s, k) => {
          if (s.broken || w.t - s.last < RALLY_CD) return;
          m.chanAt(me, 'rally' + k, s.x, s.y, 170, RALLY_T, '激揚吏士', () => {
            s.mo = 100; s.last = w.t; V.rallies++;
            for (const u of s.men) if (u.alive) w.addBuff(u, { id: '激揚', t: 25, atkP: 0.3, armor: 4 });
            w.dmgEvents.push({ x: s.x, y: s.y - 200, text: '激揚吏士！', team: 0, src: me.id });
            m.line(s.name, ['都督來了！', '都督還在！弟兄們站穩！', '周郎無恙！'][V.rallies % 3]);
          }, { hurt: false });
        });
        // 傷口迸裂：放技能就扣血
        for (let k = 0; k < 4; k++) { if (me.cd[k] > V.cd0[k] + 0.05) { V.bled++; m.hurt(me, me.maxHp * BLEED, 1, { quiet: false }); w.tell(me, '傷口迸裂！', 'warn'); } }
        V.cd0 = me.cd.slice();
        // 大軍往營前壓；先鋒去打營落
        const k = Math.min(1, (w.t - V.upT) / CAO_T), fx = LINE[0] - (LINE[0] - FRONT[0] - 250) * k;
        for (const u of V.army) if (u.alive && !u.rout && !u.raid) { if (!(u.target && u.target.alive)) u.home = [fx + (u.x % 5) * 20, u.home[1]]; }
        V.cr.home = [fx + 300, LINE[1]];
        V.raidT = (V.raidT || 8) - dt;
        if (V.raidT <= 0) {
          V.raidT = 14;
          const s = V.st.filter((q) => !q.broken)[Math.floor(SG.rand() * 5) % Math.max(1, V.st.filter((q) => !q.broken).length)];
          if (s) for (let i = 0; i < 3; i++) { const u = m.foe('huangjin', FRONT[0] + 900, s.y + (i - 1) * 80, Object.assign({}, CAOJUN, { name: '曹軍先鋒' })); u.raid = s; u.home = [s.x, s.y]; }
        }
        // 士氣：一直往下掉，曹軍靠近掉得更快；周瑜在附近就不太掉
        for (const s of V.st) {
          if (s.broken) continue;
          const foes = w.units.some((u) => u.alive && u.team === 1 && SG.gd(u.x, u.y, s.x, s.y) < 600);
          const near = m.near(me, s.x, s.y, 450);
          s.mo -= (near ? 0 : DECAY + (foes ? FEAR : 0)) * dt;
          if (s.mo <= 0) {
            s.mo = 0; s.broken = true; V.broken++; m.unmark('s' + V.st.indexOf(s));
            for (const u of s.men) if (u.alive) { u.home = [CAMP[0] - 1600, u.y]; u.untargetable = true; u.ms = 300; m.after(5, () => { u.alive = false; u.counted = true; }); }
            m.big(`${s.name}潰散了！`);
            if (V.broken >= 2) { m.lose('營中大亂，曹仁攻破營壘'); return false; }
          }
        }
        const live = V.st.filter((s) => !s.broken), avg = live.reduce((a, s) => a + s.mo, 0) / V.st.length;
        V.avg = avg;
        m.get('rally').text = `激揚吏士：五營平均士氣 ${Math.round(avg)}（潰散 ${V.broken} 處）`;
        m.get('cao').text = left > 0 ? `曹仁大軍壓到營前還有 ${Math.ceil(left)} 秒` : '曹仁到了營前';
        if (left > 0) return false;
        if (avg >= 50) return true;
        m.lose('營中士氣低落，曹仁攻破營壘');
        return false;
      },
    },
    { // 4. 仁由是遂退
      enter(m, w) {
        const V = m.vars;
        m.done('rally'); m.done('cao');
        V.st.forEach((s, k) => m.unmark('s' + k));
        m.line('曹仁', '周瑜……他還能起來？營中嚴整如故。退兵！');
        m.card('仁由是遂退。', '《周瑜傳》');
        rout(m, w, w.units.filter((u) => u.alive && u.team === 1), [LINE[0] + 1600, LINE[1]]);
        m.after(6, () => m.card('瑜、仁相守歲餘，所殺傷甚眾。仁委城走。權以瑜為南郡太守。', '《吳主傳》'));
        m.after(12, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const me = w.player, V = m.vars;
    if (!me.alive) { m.lose('周瑜傷重不起'); return; }
    if (V.cp) { allyTick(w, V.cp, me); allyTick(w, V.gn, me); }
  },
};
